<template>
  <DialogBase
    title="Cập nhật nhóm học sinh"
    :visible.sync="dialogVisible"
    size="sm"
    panel-icon="el-icon-edit"
    panel-title="Thông tin nhóm"
    panel-subtitle="Chỉnh sửa thông tin nhóm học sinh"
    :confirm-loading="loadingButton"
    :confirm-disabled="!showSaveChange"
    confirm-text="Lưu"
    confirm-type="primary"
    cancel-text="Hủy"
    cancel-type=""
    cancel-icon=""
    confirm-icon=""
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleSave"
  >
    <el-form
      ref="dataForm"
      :model="editKidsGroup"
      :rules="formRules"
      label-position="top"
    >
      <el-form-item label="Tên nhóm" prop="groupName">
        <el-input
          v-model="editKidsGroup.groupName"
          placeholder="Nhập tên nhóm"
          @keyup.enter.native="handleSave"
        />
        <span v-if="customErrorMessages.newNameKt" class="sk-note sk-note--danger sk-u-mt-12">
          <i class="el-icon-warning-outline" />
          <span>{{ customErrorMessages.newNameKt }}</span>
        </span>
      </el-form-item>
      <el-form-item label="Mô tả" prop="description" class="sk-u-mt-12">
        <el-input
          v-model="editKidsGroup.description"
          type="textarea"
          :rows="1"
          autosize
          placeholder="Nhập mô tả"
        />
      </el-form-item>
    </el-form>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import KidsGroupService from "@/services/KidsService/KidsGroupService";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { DialogBase },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    editKidsGroup: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters("studentStore", ["kidsGroupList"]),
  },
  data() {
    return {
      newKidsGroupUpdated: null,
      loadingButton: false,
      customErrorMessages: {
        newNameKt: "",
      },
      showSaveChange: false,
      formRules: {
        groupName: [
          {
            validator: this.changeGroupName,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    ...mapActions("studentStore", ["fetchDataKidsGroupList"]),

    handleClose(done) {
      this.showSaveChange = false;
      this.customErrorMessages.newNameKt = "";
      this.$emit("dialog-close");
      this.$nextTick(() => {
        if (this.$refs.dataForm) {
          this.$refs.dataForm.resetFields();
        }
      });
      if (typeof done === "function") done();
    },

    changeGroupName(rule, value, callback) {
      for (let i = 0; i < this.kidsGroupList.length; i++) {
        if (!value) {
          this.customErrorMessages.newNameKt =
            "Giá trị không được để trống!";
          this.showSaveChange = false;
          break;
        } else if (
          value.toLowerCase().replace(/\s/g, "") ===
          this.kidsGroupList[i].groupName.toLowerCase().replace(/\s/g, "")
        ) {
          this.customErrorMessages.newNameKt =
            "Tên nhóm: " +
            this.kidsGroupList[i].groupName +
            " đã tồn tại!";
          this.showSaveChange = false;
          break;
        } else {
          this.showSaveChange = true;
          this.customErrorMessages.newNameKt = "";
          callback();
        }
      }
    },

    async handleSave() {
      await this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          KidsGroupService.update(this.editKidsGroup.id, this.editKidsGroup)
            .then((response) => {
              this.fetchDataKidsGroupList();
              this.newKidsGroupUpdated = response.data.data;
              this.$message({
                message: "Cập nhật nhóm thành công",
                type: "success",
              });
              this.handleClose();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: "error",
              });
            })
            .finally(() => {
              this.loadingButton = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog";
</style>
